import React, { PureComponent } from "react";
import moment from "moment-timezone";
import { PropTypes } from "prop-types";

import { buildMeasurementData } from "./PunchChartUtils.js";

class PunchChart extends PureComponent {
  static propTypes = {
    data: PropTypes.array,
    copy: PropTypes.object.isRequired
  };

  renderHours = data => {
    let count = 0;

    return data.map(item => {
      let className = "block";
      if (item) {
        if (item.value > 0) className += " active";
        if (item.value < 0) className += " inactive";
      }

      if (item.gap === true) {
        return (
          <div key={item.id} className={className}>
            -
          </div>
        );
      }

      if (item.sub) {
        className += " sub";
        if (item.sub.value > 0) className += "-active";
        if (item.sub.value < 0) className += "-inactive";
      }

      return <div key={item.id} className={className} />;
    });
  };

  renderDay = data => {
    return (
      <div key={data.id} className="day">
        <div key={`${data.id}-label`} className="row-label">
          {data.label}
        </div>
        {this.renderHours(data.days)}
      </div>
    );
  };

  renderDays = () => {
    const measurements = buildMeasurementData(this.props.data);

    return measurements.map(item => {
      return this.renderDay(item);
    });
  };

  renderHeader = () => {
    const hours = [];

    const day = moment.utc().minute(0).hour(0);

    for (let i = 0; i < 24; i++) {
      hours.push(
        <div key={`hour-${i}`} className="block">
          {day.format("HH:00")}
        </div>
      );
      day.add(1, "hour");
    }

    return (
      <div className="time">
        <div key={"hour-label"} className="row-label" />
        {hours}
      </div>
    );
  };

  render() {
    if (!this.props.data || this.props.data.length < 1) return null;

    return (
      <div className="punch-chart">
        {this.renderHeader()}
        <div className="days">{this.renderDays()}</div>
      </div>
    );
  }
}

export default PunchChart;
